import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/pl';

dayjs.locale('pl');

// API format (ISO 8601 date-only)
export const API_DATE_FORMAT = 'YYYY-MM-DD';

// Display format (Polish locale)
export const DISPLAY_DATE_FORMAT = 'DD.MM.YYYY';

/**
 * Returns today's date in API format (YYYY-MM-DD)
 */
export const today = (): string => dayjs().format(API_DATE_FORMAT);

/**
 * Returns date N days from now in API format
 */
export const plusDays = (days: number): string => {
  return dayjs().add(days, 'day').format(API_DATE_FORMAT);
};

/**
 * Converts Date/Dayjs to API string format (YYYY-MM-DD)
 */
export const formatApiDate = (date: Dayjs | Date | null | undefined): string => {
  if (!date) return '';
  return dayjs(date).format(API_DATE_FORMAT);
};

/**
 * Parses API date string (YYYY-MM-DD) to Dayjs object
 * Returns null for invalid dates or default .NET date (0001-01-01)
 */
export const parseApiDate = (dateString?: string | null): Dayjs | null => {
  if (!dateString || dateString === '0001-01-01') return null;
  return dayjs(dateString, API_DATE_FORMAT);
};

/**
 * Formats date for display (DD.MM.YYYY)
 */
export const formatDisplayDate = (dateString?: string | null): string => {
  const date = parseApiDate(dateString);
  return date ? date.format(DISPLAY_DATE_FORMAT) : '—';
};

/**
 * Normalizes API date string (removes default .NET dates)
 */
export const normalizeDate = (d?: string): string | undefined => {
  return d && d !== '0001-01-01' ? d : undefined;
};

/**
 * Converts Date to ISO string (use only if necessary)
 * @deprecated Use formatApiDate() instead
 */
export const isoDate = (d: Date) => d.toISOString().slice(0, 10);
